const Partners = (function () {

    const $ = require('jquery');
    const Vue = require('./../../../../build/node_modules/@components/vuejs/dist/vue.min.js');
    const self = {};

    self.$autocomplete = $('#location-results');

    self.init = function () {

        if (self.$autocomplete.length > 0) {

            Vue.filter('highlight', function (word, query) {
                let check = new RegExp(query, 'ig');
                return word.toString().replace(check, function (matchedText, a, b) {
                    return '<strong>' + matchedText + '</strong>';
                });
            });

            let App = new Vue({
                el: '#location-results',
                data: {
                    search: '',
                    showResults: false,
                    posts: [],
                    keyWordHittedPosts: []
                },
                mounted: function () {
                    $.ajax({
                        cache: false,
                        dataType: 'json',
                        data: {
                            no_paging: true,
                            json: true
                        },
                        url: '/locaties/'
                    }).done(function (response) {
                        App.posts = response.posts;
                    });
                },
                computed: {
                    computedPosts: function () {

                        let self = this;
                        this.keyWordHittedPosts = [];

                        let posts = self.posts.filter(function (post) {

                            if (post.custom.location__search_keywords) {
                                let keyword_hit = false;

                                if (post.custom.location__search_keywords.toLowerCase().indexOf(self.search.toLowerCase()) >= 0) {
                                    keyword_hit = true;

                                    self.keyWordHittedPosts[post.id] = [post];
                                }

                                if ( keyword_hit ) return true;
                            }
                            return post.post_title.toLowerCase().indexOf(self.search.toLowerCase()) >= 0;
                        });

                        self.showResults = posts.length > 0 && self.search;

                        // highlight keywords and return posts
                        return posts.map(function(post) {

                            // create a clone because we don't want to manipulate the post in the self.posts array
                            let the_post = $.extend( {}, post );
                            if ( self.keyWordHittedPosts[post.id] !== undefined ) {
                                the_post.post_title = post.post_title;
                            }

                            return the_post;
                        } );

                    }
                }
            });

        }

    };

    return self;

}());

module.exports = Partners;
